var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { fabric } from 'fabric';
import { I18n, debounce, loadFont, findScaleToContain } from '@mademine/utils';
import { loadHTMLImage, loadImageFromURL, loadSVGFromURL, thumbnailOss, getBlobUrl, getZIndex, replaceUrlAsOss } from '../../utils';
import { fabricConfig } from '../../config';
import { Header, Icon, Loading } from '@mademine/components';
import { TaskStatus } from '..';
import { getKeyPoint } from '../../utils';
import { ReactComponent as LeftIcon } from '../../assets/icon-arrow-bold-left.svg';
import { ReactComponent as SubscriptIcon } from '../../assets/icon-subscript.svg';
import { ReactComponent as LineCloseIcon } from '../../assets/icon-line-close.svg';
import { ReactComponent as LineCheckIcon } from '../../assets/icon-line-check.svg';
import { ReactComponent as IconLineEditPen } from '../../assets/icon-line-edit-pen.svg';
import ColorButton from '../../components/color/Button';
import ColorDrawer from '../../components/color/Drawer';
import { drawBorders, drawControl, render } from './override.js';
import { useData } from '../../hooks/useData';
import classNames from 'classnames';
import FlipButton from '../../components/color/Flipper';
import VisualizeButton from '../../components/color/Visualizer';
var _a = fabricConfig.control, mirror = _a.mirror, scale = _a.scale, rotate = _a.rotate, camera = _a.camera, deleteImage = _a.deleteImage;
var _b = fabricConfig.attribute, borderScaleFactor = _b.borderScaleFactor, cornerSize = _b.cornerSize;
var Preview = function (_a) {
    var _b, _c, _d;
    var images = _a.images, miniMeImage = _a.miniMeImage, sideCount = _a.sideCount, selectedColor = _a.selectedColor, colorVariants = _a.colorVariants, defaultTemplateId = _a.defaultTemplateId, isPassEdit = _a.isPassEdit, handleChangeIsFirst = _a.handleChangeIsFirst, handleIncrementDrawer = _a.handleIncrementDrawer, loadShareImage = _a.loadShareImage, setCurrentSide = _a.setCurrentSide, setFactoryData = _a.setFactoryData, setColorVariantsValue = _a.setColorVariantsValue, setIncrementDrawerVisible = _a.setIncrementDrawerVisible, setImageDrawerVisible = _a.setImageDrawerVisible, setZuploaderVisible = _a.setZuploaderVisible, setTaskStatus = _a.setTaskStatus, setImages = _a.setImages;
    var _e = useData(), productType = _e.productType, canvasData = _e.canvasData, currentSide = _e.currentSide, _f = _e.shop, theme = _f.theme, language = _f.language, EditPageNextElement = _e.EditPageNextElement, setEditVisible = _e.setEditVisible, setPeopleIndex = _e.setPeopleIndex, setHasBackSideUpload = _e.setHasBackSideUpload, setViualizerPreviewVisible = _e.setViualizerPreviewVisible, setImageDataFor3dPreview = _e.setImageDataFor3dPreview;
    var _annexImages = useRef({});
    var _texts = useRef({});
    var _canvasWrapper = useRef(null);
    var _element = useRef(null);
    var _canvas = useRef();
    var _multiple = useRef(0);
    var _bodyLayer = useRef();
    var _ballonStrokeLayer = useRef();
    var _textImage = useRef([]);
    var _g = useState(undefined), selectedEdit = _g[0], setSelectedEdit = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(false), colorOptionsVisible = _j[0], setColorOptionsVisible = _j[1];
    var _k = useState(false), colorVisiable = _k[0], setColorVisiable = _k[1];
    var _l = useState(false), isEditText = _l[0], setIsEditText = _l[1];
    var _m = useState(''), editTempText = _m[0], setEditTempText = _m[1];
    var _o = useState(false), showTextTip = _o[0], setShowTextTip = _o[1];
    var _p = useState(false), operatingFlip = _p[0], setOperatingFlip = _p[1];
    var _q = useState(false), directToPreview = _q[0], setDirectToPreview = _q[1];
    var _r = useState(false), flipButtonClickTag = _r[0], setFlipButtonClickTag = _r[1];
    var currentAvatar = images
        .map(function (item) { return item[currentSide - 1]; })
        .filter(Boolean);
    var annexImages = (_b = miniMeImage.annex) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        var url = item.images.find(function (image) {
            return image.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
        }).url;
        return {
            id: item.id,
            image: url
        };
    });
    var renderTextImage = function () {
        if (!miniMeImage.text)
            return Promise.reject();
        return Promise.all(miniMeImage.text.map(function (textItem, index) { return __awaiter(void 0, void 0, void 0, function () {
            var element, canvas, canvasWidth, canvasHeight, textWidthScale, textHeightScale, scale, textValue, fabricText, data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        element = document.createElement('canvas');
                        canvas = new fabric.Canvas(element);
                        canvas.setDimensions({
                            width: 300,
                            height: (textItem.height / textItem.width) * 300
                        });
                        canvasWidth = canvas.getWidth();
                        canvasHeight = canvas.getHeight();
                        textWidthScale = canvasWidth / textItem.width;
                        textHeightScale = canvasHeight / textItem.height;
                        scale = Math.min(textWidthScale, textHeightScale);
                        return [4, loadFont(textItem.font)];
                    case 1:
                        _b.sent();
                        textValue = textItem.text ||
                            (typeof textItem.defaultText === 'string'
                                ? textItem.defaultText
                                : (_a = textItem.defaultText) === null || _a === void 0 ? void 0 : _a[language]) ||
                            I18n.format('text.default.text') ||
                            '';
                        fabricText = new fabric.Text(textValue, {
                            fontFamily: textItem.font.name,
                            fontSize: textItem.fontSize * scale,
                            lineHeight: textItem.lineHeight
                                ? (textItem.lineHeight * scale) / (textItem.fontSize * scale)
                                : 1.16,
                            left: canvasWidth / 2,
                            top: canvasHeight / 2,
                            originX: 'center',
                            originY: 'center',
                            charSpacing: textItem.charSpacing || 0,
                            width: textItem.width * scale,
                            height: textItem.height * scale,
                            textAlign: 'center'
                        });
                        handleFabricTextScale(fabricText, textItem.width * scale, textItem.height * scale);
                        canvas.add(fabricText);
                        canvas.renderAll();
                        data = {
                            id: "text-".concat(index),
                            image: canvas.toDataURL()
                        };
                        canvas.clear();
                        canvas.dispose();
                        element.width = element.height = 0;
                        return [2, data];
                }
            });
        }); }));
    };
    var selectedText = useMemo(function () {
        if (!miniMeImage.text ||
            typeof selectedEdit !== 'string' ||
            !selectedEdit.startsWith('text')) {
            return undefined;
        }
        return miniMeImage.text[Number(selectedEdit.split('-')[1])];
    }, [miniMeImage.text, selectedEdit]);
    var optionList = __spreadArray(__spreadArray(__spreadArray([], (annexImages !== null && annexImages !== void 0 ? annexImages : []), true), currentAvatar.map(function (item, index) { return ({
        id: "avatar-".concat(index),
        image: item.image || ''
    }); }), true), _textImage.current, true);
    var setActiveObject = function (id) {
        var _a, _b, _c, _d, _e;
        setSelectedEdit("".concat(id));
        id = "".concat(id);
        if (id.startsWith('avatar')) {
            var index = parseFloat(id.split('-')[1]);
            setPeopleIndex(index);
            (_a = _canvas.current) === null || _a === void 0 ? void 0 : _a.setActiveObject(_annexImages.current[id]);
            setIsEditText(false);
            setShowTextTip(false);
        }
        else if (id.startsWith('text')) {
            (_b = _canvas.current) === null || _b === void 0 ? void 0 : _b.discardActiveObject();
            if (miniMeImage.text) {
                setEditTempText(miniMeImage.text[Number(id.split('-')[1])].text || '');
            }
            setIsEditText(true);
        }
        else {
            _annexImages.current[id].opacity = 1;
            _annexImages.current[id].selectable = true;
            _annexImages.current[id].evented = true;
            (_c = _canvas.current) === null || _c === void 0 ? void 0 : _c.bringToFront(_annexImages.current[id]);
            (_d = _canvas.current) === null || _d === void 0 ? void 0 : _d.setActiveObject(_annexImages.current[id]);
            setIsEditText(false);
            setShowTextTip(false);
        }
        (_e = _canvas.current) === null || _e === void 0 ? void 0 : _e.renderAll();
    };
    var setControl = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, tl, tr, bl, br, options;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!_canvas.current) return [3, 2];
                    return [4, Promise.all([
                            loadHTMLImage(camera),
                            loadHTMLImage(scale),
                            loadHTMLImage(mirror),
                            loadHTMLImage(rotate)
                        ])];
                case 1:
                    _a = _b.sent(), tl = _a[0], tr = _a[1], bl = _a[2], br = _a[3];
                    options = {
                        actionHandler: undefined,
                        cursorStyleHandler: function () {
                            return 'pointer';
                        }
                    };
                    fabric.Object.prototype.controls.tl = Object.assign(fabric.Object.prototype.controls.tl, __assign(__assign({}, options), { image: tl, actionName: 'edit', mouseUpHandler: function (e, transform) {
                            var customHandler = transform.target.customControl &&
                                transform.target.customControl[transform.action]
                                ? transform.target.customControl[transform.action]
                                    .mouseUpHandler
                                : undefined;
                            if (customHandler)
                                customHandler(e, transform);
                            else
                                setEditVisible(true);
                        } }));
                    fabric.Object.prototype.controls.tr = Object.assign(fabric.Object.prototype.controls.tr, { image: tr, actionName: 'scale' });
                    fabric.Object.prototype.controls.bl = Object.assign(fabric.Object.prototype.controls.bl, __assign(__assign({}, options), { image: bl, actionName: 'flipX', mouseUpHandler: function (_, transform) {
                            var _a;
                            transform.target.flipX = !transform.target.flipX;
                            (_a = _canvas.current) === null || _a === void 0 ? void 0 : _a.renderAll();
                        } }));
                    fabric.Object.prototype.controls.br = Object.assign(fabric.Object.prototype.controls.br, {
                        image: br,
                        actionName: 'rotate',
                        actionHandler: fabric.Object.prototype.controls.mtr.actionHandler.bind(fabric.Object.prototype.controls.br),
                        cursorStyleHandler: fabric.Object.prototype.controls.mtr.cursorStyleHandler
                    });
                    fabric.Object.prototype.controls.tl.render = render;
                    fabric.Object.prototype.controls.tr.render = render;
                    fabric.Object.prototype.controls.bl.render = render;
                    fabric.Object.prototype.controls.br.render = render;
                    fabric.Object.prototype.setControlsVisibility({
                        mb: false,
                        mr: false,
                        ml: false,
                        mt: false,
                        mtr: false
                    });
                    _b.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var renderAvatarPath = function () { return __awaiter(void 0, void 0, void 0, function () {
        var type, avatar, pathArr, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    type = miniMeImage.type, avatar = miniMeImage.avatar;
                    pathArr = avatar
                        .map(function (item, index) { return ({
                        path: item.path || '',
                        index: index
                    }); })
                        .filter(function (item) { return item.path; });
                    if (pathArr.length === 0 ||
                        (type !== 'hood' && type !== 'balloon') ||
                        !_canvas.current) {
                        return [2, undefined];
                    }
                    result = {};
                    return [4, Promise.all(pathArr.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                            var canvasWidth, canvasHeight, pathImage, pathLeft, pathTop;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!_canvas.current)
                                            return [2, undefined];
                                        canvasWidth = _canvas.current.getWidth();
                                        canvasHeight = _canvas.current.getHeight();
                                        return [4, loadSVGFromURL(item.path)];
                                    case 1:
                                        pathImage = _c.sent();
                                        pathLeft = (((_a = pathImage.left) !== null && _a !== void 0 ? _a : 0) / miniMeImage.width) * canvasWidth;
                                        pathTop = (((_b = pathImage.top) !== null && _b !== void 0 ? _b : 0) / miniMeImage.height) * canvasHeight;
                                        pathImage
                                            .set({
                                            fill: 'transparent',
                                            absolutePositioned: true,
                                            left: pathLeft,
                                            top: pathTop
                                        })
                                            .scale(Math.min(canvasWidth / miniMeImage.width, canvasHeight / miniMeImage.height));
                                        result[item.index] = pathImage;
                                        return [2, { object: pathImage, index: item.index }];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    return [2, result];
            }
        });
    }); };
    var renderBodyImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canvasWidth, canvasHeight, imageOriginURL, imageURL, bodyImage, scale_1, factoryData;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!_canvas.current) return [3, 2];
                    canvasWidth = _canvas.current.getWidth();
                    canvasHeight = _canvas.current.getHeight();
                    imageOriginURL = miniMeImage.images.find(function (item) {
                        return item.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                    }).url;
                    imageURL = thumbnailOss(imageOriginURL, 600);
                    if (_bodyLayer.current)
                        _canvas.current.remove(_bodyLayer.current);
                    return [4, loadImageFromURL(imageURL)];
                case 1:
                    bodyImage = _b.sent();
                    _bodyLayer.current = bodyImage;
                    scale_1 = Math.min(canvasWidth / bodyImage.width, canvasHeight / bodyImage.height);
                    bodyImage.set({
                        left: canvasWidth / 2,
                        top: canvasHeight,
                        originY: 'bottom',
                        originX: 'center',
                        scaleX: scale_1,
                        scaleY: scale_1,
                        selectable: false,
                        hoverCursor: 'default',
                        perPixelTargetFind: true
                    });
                    _canvas.current.add(bodyImage);
                    bodyImage.sendToBack();
                    factoryData = {
                        makeWidth: miniMeImage.width,
                        makeHeight: miniMeImage.height,
                        layoutWidth: _canvas.current.getWidth(),
                        layoutHeight: _canvas.current.getHeight(),
                        color: selectedColor,
                        body: {
                            image: replaceUrlAsOss(imageOriginURL),
                            zIndex: getZIndex('body', miniMeImage)
                        },
                        isBodyFlip: (_a = miniMeImage.isBodyFlip) !== null && _a !== void 0 ? _a : false,
                        sideCount: 1
                    };
                    setFactoryData(factoryData);
                    return [2, bodyImage];
                case 2: return [2];
            }
        });
    }); };
    var renderBalloonStrokeImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canvasWidth, canvasHeight, imageOriginURL, imageURL, bodyStrokeImage, scale_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(_canvas.current &&
                        productType === 'balloon' &&
                        miniMeImage.strokeImages)) return [3, 2];
                    canvasWidth = _canvas.current.getWidth();
                    canvasHeight = _canvas.current.getHeight();
                    imageOriginURL = miniMeImage.strokeImages;
                    imageURL = thumbnailOss(imageOriginURL, 600);
                    if (_ballonStrokeLayer.current)
                        _canvas.current.remove(_ballonStrokeLayer.current);
                    return [4, loadImageFromURL(imageURL)];
                case 1:
                    bodyStrokeImage = _a.sent();
                    _ballonStrokeLayer.current = bodyStrokeImage;
                    scale_2 = Math.min(canvasWidth / bodyStrokeImage.width, canvasHeight / bodyStrokeImage.height);
                    bodyStrokeImage.set({
                        left: canvasWidth / 2,
                        top: canvasHeight,
                        originY: 'bottom',
                        originX: 'center',
                        scaleX: scale_2,
                        scaleY: scale_2,
                        selectable: false,
                        hoverCursor: 'default',
                        perPixelTargetFind: true
                    });
                    _canvas.current.add(bodyStrokeImage);
                    return [2, bodyStrokeImage];
                case 2: return [2];
            }
        });
    }); };
    var renderAvatar = function (avatarImage, index, pathImage) { return __awaiter(void 0, void 0, void 0, function () {
        var face, avatar, canvasWidth, canvasHeight, imageData, avatarLeft, avatarTop, scale_3, avatarData, faceRect, faceItem, faceWidth, faceHeight, heightDistance, avatarWidth, avatarItem, avatarWidth, avatarHeight;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            face = miniMeImage.face, avatar = miniMeImage.avatar;
            canvasWidth = _canvas.current.getWidth();
            canvasHeight = _canvas.current.getHeight();
            if (canvasData.current[currentSide - 1]) {
                imageData = (_a = canvasData.current[currentSide - 1].image) === null || _a === void 0 ? void 0 : _a.avatar[index];
                if (!imageData)
                    return [2];
                avatarImage.set({
                    name: "avatar-".concat(index),
                    left: imageData.left,
                    top: imageData.top,
                    scaleX: imageData.scaleX,
                    scaleY: imageData.scaleY,
                    angle: imageData.rotate,
                    flipX: imageData.flipX,
                    flipY: imageData.flipY,
                    originY: 'center',
                    originX: 'center',
                    selectable: true,
                    borderColor: "rgb(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ")"),
                    padding: 10,
                    borderScaleFactor: Math.round(borderScaleFactor * _multiple.current),
                    cornerSize: cornerSize * _multiple.current
                });
            }
            else {
                avatarLeft = 0;
                avatarTop = 0;
                scale_3 = 0;
                avatarData = currentAvatar[index];
                if (avatarData.faceRecognizeData && face) {
                    faceRect = avatarData.faceRecognizeData.faceRect;
                    faceItem = face[index];
                    faceWidth = (faceItem.width / miniMeImage.width) * canvasWidth;
                    faceHeight = (faceItem.height / miniMeImage.height) * canvasHeight;
                    scale_3 = Math.min(faceWidth / faceRect.width, faceHeight / faceRect.height);
                    heightDistance = (avatarImage.height - faceRect.top - faceRect.height) *
                        scale_3;
                    avatarTop =
                        ((faceItem.top + faceItem.height) / miniMeImage.height) *
                            canvasHeight +
                            heightDistance;
                    avatarWidth = avatarImage.width * scale_3;
                    avatarLeft =
                        (faceItem.left / miniMeImage.width) * canvasWidth -
                            faceRect.left * scale_3 +
                            avatarWidth / 2;
                }
                else {
                    avatarItem = avatar[index];
                    avatarWidth = (avatarItem.width / miniMeImage.width) * canvasWidth;
                    avatarHeight = (avatarItem.height / miniMeImage.height) * canvasHeight;
                    scale_3 = Math.min(avatarWidth / ((_b = avatarImage.width) !== null && _b !== void 0 ? _b : 0), avatarHeight / ((_c = avatarImage.height) !== null && _c !== void 0 ? _c : 0));
                    avatarLeft =
                        ((avatarItem.left + avatarItem.width / 2) / miniMeImage.width) *
                            canvasWidth;
                    avatarTop =
                        ((avatarItem.top + avatarItem.height) / miniMeImage.height) *
                            canvasHeight;
                }
                avatarImage.set({
                    name: "avatar-".concat(index),
                    left: avatarLeft,
                    top: avatarTop,
                    originX: 'center',
                    originY: 'bottom',
                    scaleX: scale_3,
                    scaleY: scale_3,
                    selectable: true,
                    borderColor: "rgb(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ")"),
                    padding: 10,
                    borderScaleFactor: Math.round(borderScaleFactor * _multiple.current),
                    cornerSize: cornerSize * _multiple.current
                });
                avatarImage.rotate(face[index].angle || 0);
            }
            if (pathImage) {
                avatarImage.set({
                    clipPath: pathImage
                });
            }
            _canvas.current.add(avatarImage);
            return [2];
        });
    }); };
    var handleAnnexControl = function (item, image) {
        item.set('customControl', {
            edit: {
                image: image,
                actionName: 'delete',
                actionHandler: undefined,
                mouseUpHandler: function (_, transform) {
                    var _a, _b, _c;
                    var target = transform.target;
                    target.opacity = 0;
                    target.selectable = false;
                    target.evented = false;
                    (_a = _canvas.current) === null || _a === void 0 ? void 0 : _a.sendToBack(target);
                    (_b = _canvas.current) === null || _b === void 0 ? void 0 : _b.discardActiveObject();
                    setSelectedEdit(undefined);
                    (_c = _canvas.current) === null || _c === void 0 ? void 0 : _c.renderAll();
                }
            }
        });
    };
    var renderAnnex = function (deleteImg) { return __awaiter(void 0, void 0, void 0, function () {
        var annex, face, canvasWidth, canvasHeight, annexsOriginURL, annexsURL, annexImages_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    annex = miniMeImage.annex, face = miniMeImage.face;
                    canvasWidth = _canvas.current.getWidth();
                    canvasHeight = _canvas.current.getHeight();
                    if (!(annex && annex.length > 0)) return [3, 2];
                    annexsOriginURL = annex.map(function (item) {
                        return item.images.find(function (image) {
                            return image.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                        }).url;
                    });
                    annexsURL = annexsOriginURL.map(function (item) { return "".concat(item, "?x-oss-process=image/resize,l_200"); });
                    annexImages_1 = [];
                    return [4, Promise.all(annexsURL.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var image;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, loadImageFromURL(item)];
                                    case 1:
                                        image = _a.sent();
                                        image._drawControl = drawControl.bind(image);
                                        image.drawBorders = drawBorders.bind(image);
                                        annexImages_1[index] = {
                                            image: image,
                                            belongIndex: annex[index].belongIndex
                                        };
                                        return [2];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    if (canvasData.current.length > currentSide) {
                        annexImages_1.forEach(function (_a, index) {
                            var _b, _c, _d;
                            var item = _a.image;
                            var currentAnnex = annex[index];
                            _annexImages.current[currentAnnex.id] = item;
                            var annexData;
                            (_c = (_b = canvasData.current[currentSide - 1].image) === null || _b === void 0 ? void 0 : _b.annexs) === null || _c === void 0 ? void 0 : _c.find(function (annexItem) { return annexItem.id === currentAnnex.id; });
                            if (!annexData)
                                return;
                            handleAnnexControl(item, deleteImg);
                            item.set({
                                name: "".concat(currentAnnex.id),
                                left: annexData === null || annexData === void 0 ? void 0 : annexData.left,
                                top: annexData === null || annexData === void 0 ? void 0 : annexData.top,
                                scaleX: annexData === null || annexData === void 0 ? void 0 : annexData.scaleX,
                                scaleY: annexData === null || annexData === void 0 ? void 0 : annexData.scaleY,
                                angle: annexData === null || annexData === void 0 ? void 0 : annexData.rotate,
                                flipX: annexData === null || annexData === void 0 ? void 0 : annexData.flipX,
                                flipY: annexData === null || annexData === void 0 ? void 0 : annexData.flipY,
                                originY: 'center',
                                originX: 'center',
                                selectable: true,
                                borderColor: "rgb(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ")"),
                                padding: 10,
                                borderScaleFactor: Math.round(borderScaleFactor * _multiple.current),
                                cornerSize: cornerSize * _multiple.current
                            });
                            (_d = _canvas.current) === null || _d === void 0 ? void 0 : _d.add(item);
                        });
                    }
                    else {
                        Object.entries(_annexImages.current).forEach(function (_a) {
                            var key = _a[0], avatarImage = _a[1];
                            if (!key.startsWith('avatar'))
                                return;
                            var peopelIndex = parseInt(key.split('-')[1]);
                            annexImages_1.forEach(function (_a, index) {
                                var _b, _c, _d;
                                var item = _a.image, belongIndex = _a.belongIndex;
                                if ((belongIndex !== undefined && belongIndex !== peopelIndex) ||
                                    (belongIndex === undefined && peopelIndex !== 0)) {
                                    return;
                                }
                                var currentAnnex = annex[index];
                                _annexImages.current[currentAnnex.id] = item;
                                handleAnnexControl(item, deleteImg);
                                var annexTop = 0;
                                var annexLeft = 0;
                                var annexScale = 0;
                                var avatarData = currentAvatar[peopelIndex];
                                if (avatarData.faceRecognizeData &&
                                    face &&
                                    productType !== 'balloon') {
                                    var faceRect = avatarData.faceRecognizeData.faceRect;
                                    var _e = currentAnnex.faceFit, leftPoint = _e.leftPoint, rightPoint = _e.rightPoint, feature = _e.feature;
                                    var avatarImageScale = avatarImage.scaleX;
                                    var avatarFaceWidth = faceRect.width * avatarImageScale;
                                    var faceItem = face[belongIndex || 0];
                                    var faceFitWidth = (faceItem.width / miniMeImage.width) * canvasWidth;
                                    var faceFitLeft = (faceItem.left / miniMeImage.width) * canvasWidth;
                                    var scale_4 = item.width / currentAnnex.width;
                                    var keyPoint = getKeyPoint(avatarData, feature);
                                    var faceLeft = faceFitLeft + (faceFitWidth - avatarFaceWidth) / 2;
                                    annexScale =
                                        avatarFaceWidth / ((rightPoint.left - leftPoint.left) * scale_4);
                                    if (feature === 'head') {
                                        annexTop =
                                            avatarImage._getLeftTopCoords().y +
                                                keyPoint.y * avatarImageScale -
                                                100 * avatarImageScale -
                                                leftPoint.top * scale_4 * annexScale +
                                                (currentAnnex.height / 2) * scale_4 * annexScale;
                                    }
                                    else {
                                        annexTop =
                                            avatarImage._getLeftTopCoords().y +
                                                keyPoint.y * avatarImageScale -
                                                leftPoint.top * scale_4 * annexScale +
                                                (currentAnnex.height / 2) * scale_4 * annexScale;
                                    }
                                    annexLeft =
                                        faceLeft -
                                            leftPoint.left * scale_4 * annexScale +
                                            (currentAnnex.width / 2) * scale_4 * annexScale;
                                }
                                else {
                                    annexLeft =
                                        ((currentAnnex.left + currentAnnex.width / 2) /
                                            miniMeImage.width) *
                                            canvasWidth;
                                    annexTop =
                                        ((currentAnnex.top + currentAnnex.height / 2) /
                                            miniMeImage.height) *
                                            canvasHeight;
                                    var annexWidth = (currentAnnex.width / miniMeImage.width) * canvasWidth;
                                    var annexHeight = (currentAnnex.height / miniMeImage.height) * canvasHeight;
                                    annexScale = Math.min(annexWidth / ((_b = item.width) !== null && _b !== void 0 ? _b : 0), annexHeight / ((_c = item.height) !== null && _c !== void 0 ? _c : 0));
                                }
                                item.set({
                                    name: "".concat(currentAnnex.id),
                                    left: annexLeft,
                                    top: annexTop,
                                    originX: 'center',
                                    originY: 'center',
                                    scaleX: annexScale,
                                    scaleY: annexScale,
                                    selectable: true,
                                    borderColor: "rgb(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ")"),
                                    padding: 10,
                                    borderScaleFactor: Math.round(borderScaleFactor * _multiple.current),
                                    cornerSize: cornerSize * _multiple.current
                                });
                                (_d = _canvas.current) === null || _d === void 0 ? void 0 : _d.add(item);
                            });
                        });
                    }
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var renderText = function () { return __awaiter(void 0, void 0, void 0, function () {
        var text, canvasWidth_1, canvasHeight_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    text = miniMeImage.text;
                    if (!text) return [3, 2];
                    canvasWidth_1 = _canvas.current.getWidth();
                    canvasHeight_1 = _canvas.current.getHeight();
                    return [4, Promise.all(text.map(function (textItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var textWidthScale, textHeightScale, scale, textLeft, textTop, textValue, fabricText;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        textWidthScale = canvasWidth_1 / miniMeImage.width;
                                        textHeightScale = canvasHeight_1 / miniMeImage.height;
                                        scale = Math.min(textWidthScale, textHeightScale);
                                        textLeft = textItem.left * scale + (scale * textItem.width) / 2;
                                        textTop = textItem.top * scale + (scale * textItem.height) / 2;
                                        return [4, loadFont(textItem.font)];
                                    case 1:
                                        _b.sent();
                                        textValue = textItem.text ||
                                            (typeof textItem.defaultText === 'string'
                                                ? textItem.defaultText
                                                : (_a = textItem.defaultText) === null || _a === void 0 ? void 0 : _a[language]) ||
                                            I18n.format('text.default.text') ||
                                            '';
                                        fabricText = new fabric.Text(textValue, {
                                            name: "text-".concat(index),
                                            fontFamily: textItem.font.name,
                                            fontSize: textItem.fontSize * scale,
                                            lineHeight: textItem.lineHeight
                                                ? (textItem.lineHeight * scale) / (textItem.fontSize * scale)
                                                : 1.16,
                                            left: textLeft,
                                            top: textTop,
                                            originX: 'center',
                                            originY: 'center',
                                            fill: textItem.color,
                                            charSpacing: textItem.charSpacing || 0,
                                            borderColor: "rgb(".concat(theme.r, ", ").concat(theme.g, ", ").concat(theme.b, ")"),
                                            padding: 10,
                                            borderScaleFactor: Math.round(borderScaleFactor * _multiple.current),
                                            cornerSize: cornerSize * _multiple.current,
                                            lockMovementX: true,
                                            lockMovementY: true,
                                            hasControls: false,
                                            hasBorders: false,
                                            hoverCursor: 'pointer',
                                            width: textItem.width * scale,
                                            height: textItem.height * scale,
                                            textAlign: 'center'
                                        });
                                        handleFabricTextScale(fabricText, textItem.width * scale, textItem.height * scale);
                                        _texts.current["text-".concat(index)] = fabricText;
                                        _canvas.current.add(fabricText);
                                        return [2];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var renderMiniMeImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, deleteImg, pathImage_1, bodyImage, avatarImages_1, bodyZIndex;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(_canvas.current && miniMeImage)) return [3, 6];
                    return [4, Promise.all([
                            loadHTMLImage(deleteImage),
                            renderAvatarPath(),
                            renderBodyImage(),
                            renderBalloonStrokeImage()
                        ])];
                case 1:
                    _a = _b.sent(), deleteImg = _a[0], pathImage_1 = _a[1], bodyImage = _a[2];
                    avatarImages_1 = [];
                    return [4, Promise.all(currentAvatar.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var avatarUrl, image;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, getBlobUrl(item.image)];
                                    case 1:
                                        avatarUrl = _a.sent();
                                        return [4, loadImageFromURL(avatarUrl)];
                                    case 2:
                                        image = _a.sent();
                                        image._drawControl = drawControl.bind(image);
                                        image.drawBorders = drawBorders.bind(image);
                                        avatarImages_1[index] = image;
                                        _annexImages.current["avatar-".concat(index)] = image;
                                        URL.revokeObjectURL(avatarUrl);
                                        return [2, image];
                                }
                            });
                        }); }))];
                case 2:
                    _b.sent();
                    return [4, Promise.all(avatarImages_1.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, renderAvatar(item, index, pathImage_1 ? pathImage_1["".concat(index)] : undefined)];
                                    case 1:
                                        _a.sent();
                                        return [2];
                                }
                            });
                        }); }))];
                case 3:
                    _b.sent();
                    return [4, renderAnnex(deleteImg)];
                case 4:
                    _b.sent();
                    return [4, renderText()];
                case 5:
                    _b.sent();
                    bodyZIndex = getZIndex('body', miniMeImage);
                    if (bodyZIndex !== 0 && bodyImage) {
                        bodyImage.moveTo(bodyZIndex);
                    }
                    currentAvatar.forEach(function (_, index) {
                        var zIndex = miniMeImage.avatar[index].zIndex || miniMeImage.face[index].zIndex;
                        if (zIndex === undefined) {
                            zIndex = getZIndex('face', miniMeImage, index);
                        }
                        var avatarImageCanvasObject = _annexImages.current["avatar-".concat(index)];
                        avatarImageCanvasObject.moveTo(zIndex);
                    });
                    setActiveObject('avatar-0');
                    _b.label = 6;
                case 6: return [2];
            }
        });
    }); };
    var canvasInit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var offsetWidth;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(_element.current &&
                        _canvasWrapper.current &&
                        currentAvatar.length > 0)) return [3, 4];
                    setLoading(true);
                    return [4, loadShareImage()];
                case 1:
                    _b.sent();
                    offsetWidth = _canvasWrapper.current.offsetWidth;
                    if (_canvas.current) {
                        (_a = _canvas.current) === null || _a === void 0 ? void 0 : _a.clear();
                    }
                    else {
                        _canvas.current = new fabric.Canvas(_element.current, {
                            selection: false,
                            preserveObjectStacking: true
                        });
                        _canvas.current.on('mouse:down', function (e) {
                            var _a, _b;
                            if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.name) {
                                if (e.target.name !== 'lineText' && e.target.opacity !== 0) {
                                    setActiveObject(e.target.name);
                                }
                            }
                            else {
                                (_b = _canvas.current) === null || _b === void 0 ? void 0 : _b.discardActiveObject();
                                setSelectedEdit(function (pre) {
                                    var _a;
                                    if (miniMeImage.text &&
                                        typeof pre === 'string' &&
                                        pre.startsWith('text')) {
                                        var operatingText = miniMeImage.text[Number(pre.split('-')[1])];
                                        var text = operatingText.text ||
                                            (typeof (operatingText === null || operatingText === void 0 ? void 0 : operatingText.defaultText) === 'string'
                                                ? operatingText === null || operatingText === void 0 ? void 0 : operatingText.defaultText
                                                : (_a = operatingText === null || operatingText === void 0 ? void 0 : operatingText.defaultText) === null || _a === void 0 ? void 0 : _a[language]) ||
                                            I18n.format('text.default.text') ||
                                            '' ||
                                            '';
                                        renderTempText(text, pre);
                                    }
                                    return undefined;
                                });
                                setIsEditText(false);
                                setShowTextTip(false);
                            }
                        });
                    }
                    _multiple.current = Math.min(offsetWidth / 375, offsetWidth / 375);
                    _canvas.current.setDimensions({
                        width: offsetWidth,
                        height: (miniMeImage.height / miniMeImage.width) * offsetWidth
                    });
                    return [4, setControl()];
                case 2:
                    _b.sent();
                    return [4, renderMiniMeImage()];
                case 3:
                    _b.sent();
                    setLoading(false);
                    if (isPassEdit)
                        handleConfirm();
                    _b.label = 4;
                case 4: return [2];
            }
        });
    }); };
    var addCanvasData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var balloonCompose;
        return __generator(this, function (_a) {
            balloonCompose = '';
            if (productType === 'balloon' && _ballonStrokeLayer.current) {
                _canvas.current.remove(_ballonStrokeLayer.current);
                _canvas.current.renderAll();
                balloonCompose = _canvas.current.getElement().toDataURL();
                _canvas.current.add(_ballonStrokeLayer.current);
                _canvas.current.renderAll();
            }
            if (miniMeImage) {
                canvasData.current[currentSide - 1] = {
                    image: {
                        id: miniMeImage.id,
                        type: miniMeImage.type,
                        avatar: [],
                        annexs: [],
                        compose: _canvas.current.getElement().toDataURL(),
                        balloonCompose: balloonCompose
                    }
                };
                Object.entries(_annexImages.current).forEach(function (_a) {
                    var _b;
                    var key = _a[0], avatarImage = _a[1];
                    if (!key.startsWith('avatar'))
                        return;
                    var belongIndex = parseInt(key.split('-')[1]);
                    var annex = Object.keys(_annexImages.current)
                        .filter(function (item) {
                        var _a;
                        var currentAnnex = _annexImages.current[item];
                        var annexData = (_a = miniMeImage.annex) === null || _a === void 0 ? void 0 : _a.find(function (element) { return currentAnnex.name === "".concat(element.id); });
                        return (!item.startsWith('avatar') &&
                            _annexImages.current[item].opacity !== 0 &&
                            (((annexData === null || annexData === void 0 ? void 0 : annexData.belongIndex) !== undefined &&
                                (annexData === null || annexData === void 0 ? void 0 : annexData.belongIndex) === belongIndex) ||
                                ((annexData === null || annexData === void 0 ? void 0 : annexData.belongIndex) === undefined && belongIndex === 0)));
                    })
                        .map(function (item) {
                        var _a;
                        var currentAnnex = _annexImages.current[item];
                        var annexData = (_a = miniMeImage.annex) === null || _a === void 0 ? void 0 : _a.find(function (element) { return currentAnnex.name === "".concat(element.id); });
                        var imageURL = annexData.images.find(function (item) {
                            return item.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
                        }).url;
                        return {
                            id: productType === 'balloon'
                                ? currentAnnex.name
                                : Number(currentAnnex.name),
                            left: currentAnnex.left,
                            top: currentAnnex.top,
                            width: currentAnnex.width,
                            height: currentAnnex.height,
                            image: imageURL,
                            scaleX: currentAnnex.scaleX,
                            scaleY: currentAnnex.scaleY,
                            rotate: currentAnnex.angle,
                            flipX: currentAnnex.flipX,
                            flipY: currentAnnex.flipY,
                            isFlip: annexData === null || annexData === void 0 ? void 0 : annexData.isFlip
                        };
                    });
                    var centerPoint = avatarImage.getCenterPoint();
                    var avatarTop = centerPoint.y;
                    var avatarLeft = centerPoint.x;
                    var index = Number(key.split('-')[1]);
                    canvasData.current[currentSide - 1].image.avatar.push({
                        left: avatarLeft,
                        top: avatarTop,
                        width: avatarImage.width,
                        height: avatarImage.height,
                        scaleX: avatarImage.scaleX,
                        scaleY: avatarImage.scaleY,
                        rotate: avatarImage.angle,
                        flipX: avatarImage.flipX,
                        flipY: avatarImage.flipY,
                        path: miniMeImage.avatar[index].path,
                        image: currentAvatar[belongIndex].image,
                        originImage: currentAvatar[belongIndex].source,
                        zIndex: miniMeImage.avatar[index].zIndex
                    });
                    if (annex) {
                        (_b = canvasData.current[currentSide - 1].image.annexs).push.apply(_b, annex);
                    }
                });
                Object.entries(_texts.current).forEach(function (_a) {
                    var key = _a[0], textObject = _a[1];
                    if (!canvasData.current[currentSide - 1].image.text) {
                        canvasData.current[currentSide - 1].image.text = [];
                    }
                    var index = key.split('-')[1];
                    var minimeData = miniMeImage.text[Number(index)];
                    canvasData.current[currentSide - 1].image.text.push({
                        left: textObject.left || 0,
                        top: textObject.top || 0,
                        font: minimeData.font,
                        color: minimeData.color,
                        fontSize: textObject.fontSize || minimeData.fontSize,
                        lineHeight: textObject.lineHeight || minimeData.lineHeight || 1.16,
                        charSpacing: textObject.charSpacing || minimeData.charSpacing || 0,
                        text: textObject.text || minimeData.text,
                        scaleX: textObject.scaleX || 1,
                        scaleY: textObject.scaleY || 1,
                        width: textObject.width || 0,
                        height: textObject.height || 0,
                        originalTextAreaWidth: minimeData === null || minimeData === void 0 ? void 0 : minimeData.width,
                        originalTextAreaHeight: minimeData === null || minimeData === void 0 ? void 0 : minimeData.height
                    });
                });
            }
            return [2];
        });
    }); };
    var handleClose = function () {
        setDirectToPreview(false);
        setHasBackSideUpload(false);
        if (currentSide > 1 || operatingFlip) {
            setCurrentSide(1);
            images[0].pop();
            if (canvasData.current.length >= 2) {
                canvasData.current.pop();
            }
            setOperatingFlip(false);
            setTaskStatus(TaskStatus.Choose);
        }
        else if (defaultTemplateId) {
            setZuploaderVisible(true);
            handleChangeIsFirst && handleChangeIsFirst();
        }
        else {
            if (sideCount === 1) {
                canvasData.current = [];
                if (miniMeImage && miniMeImage.text) {
                    miniMeImage.text.forEach(function (item) {
                        item.text = '';
                    });
                }
            }
            setIsEditText(false);
            setTaskStatus(TaskStatus.Choose);
        }
    };
    var handleConfirm = function () {
        var _a, _b;
        _canvas.current.discardActiveObject();
        _canvas.current.renderAll();
        if (colorVariants && colorVariants.length > 0) {
            setColorOptionsVisible(true);
        }
        else if ((_a = miniMeImage.text) === null || _a === void 0 ? void 0 : _a.some(function (item) { return !item.text; })) {
            setShowTextTip(true);
            setIsEditText(true);
            setEditTempText('');
            var textIndex = (_b = miniMeImage.text) === null || _b === void 0 ? void 0 : _b.findIndex(function (item) { return !item.text; });
            setActiveObject("text-".concat(textIndex));
        }
        else
            resolveDrawer();
    };
    var handleClick3dPreview = function () {
        _canvas.current.discardActiveObject();
        _canvas.current.renderAll();
        var originalCanvas = _canvas.current.getElement();
        var canvasCopy = document.createElement('canvas');
        canvasCopy.width = originalCanvas.width;
        canvasCopy.height = originalCanvas.height;
        var ctx = canvasCopy.getContext('2d');
        if (ctx) {
            ctx.save();
            ctx.resetTransform();
            ctx.setTransform(-Math.cos(Math.PI), -Math.sin(Math.PI), Math.sin(Math.PI), Math.cos(Math.PI), 0, canvasCopy.height);
            ctx.globalCompositeOperation = 'copy';
            ctx.drawImage(originalCanvas, 0, 0);
            ctx.restore();
        }
        setImageDataFor3dPreview(canvasCopy.toDataURL());
    };
    var resolveDrawer = function () {
        if (directToPreview) {
            addCanvasData();
            if (canvasData.current.length > 1) {
                if (!flipButtonClickTag) {
                    setImageDrawerVisible(true);
                }
                setFlipButtonClickTag(false);
            }
            else {
                handleIncrementDrawer();
            }
        }
        else if (currentSide < sideCount) {
            addCanvasData();
            setIncrementDrawerVisible(true);
        }
        else {
            addCanvasData();
            if (canvasData.current.length > 1) {
                setImageDrawerVisible(true);
            }
            else {
                handleIncrementDrawer();
            }
        }
    };
    var changeAssect = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!_canvas.current)
                        return [2];
                    setLoading(true);
                    return [4, renderBodyImage()];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2];
            }
        });
    }); };
    var handleCloseEditText = function () {
        var _a;
        setIsEditText(false);
        renderTempText((selectedText === null || selectedText === void 0 ? void 0 : selectedText.text) ||
            (selectedText === null || selectedText === void 0 ? void 0 : selectedText.defaultText) ||
            (typeof (selectedText === null || selectedText === void 0 ? void 0 : selectedText.defaultText) === 'string'
                ? selectedText === null || selectedText === void 0 ? void 0 : selectedText.defaultText
                : (_a = selectedText === null || selectedText === void 0 ? void 0 : selectedText.defaultText) === null || _a === void 0 ? void 0 : _a[language]) ||
            I18n.format('text.default.text') ||
            '', selectedEdit);
        setSelectedEdit(undefined);
    };
    var handleConfirmText = function () { return __awaiter(void 0, void 0, void 0, function () {
        var text, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (miniMeImage.text && typeof selectedEdit === 'string') {
                        text = miniMeImage.text[Number(selectedEdit.split('-')[1])];
                        miniMeImage.text[Number(selectedEdit.split('-')[1])] = __assign(__assign({}, text), { text: editTempText });
                        miniMeImage.text = __spreadArray([], miniMeImage.text, true);
                    }
                    _a = _textImage;
                    return [4, renderTextImage()];
                case 1:
                    _a.current = _b.sent();
                    setIsEditText(false);
                    setSelectedEdit(undefined);
                    return [2];
            }
        });
    }); };
    var renderTempText = useCallback(debounce(function (value, selectedId) {
        var _a, _b;
        (_a = _texts.current[selectedId]) === null || _a === void 0 ? void 0 : _a.set({ text: value });
        var index = Number(selectedId.split('-')[1]);
        var canvasWidth = _canvas.current.getWidth();
        var canvasHeight = _canvas.current.getHeight();
        var textWidthScale = canvasWidth / miniMeImage.width;
        var textHeightScale = canvasHeight / miniMeImage.height;
        var scale = Math.min(textWidthScale, textHeightScale);
        handleFabricTextScale(_texts.current[selectedId], miniMeImage.text[index].width * scale, miniMeImage.text[index].height * scale);
        (_b = _canvas.current) === null || _b === void 0 ? void 0 : _b.renderAll();
    }, 300), []);
    var handleFabricTextScale = function (text, width, height) {
        var textContext = text.getMeasuringContext();
        textContext.font = "".concat(text.fontSize, "px ").concat(text.fontFamily);
        textContext.textBaseline = 'top';
        var actualWidth = 0;
        for (var i = 0; i < text.textLines.length; i += 1) {
            var _a = textContext.measureText(text.textLines[i] || ''), alignToLeft = _a.actualBoundingBoxLeft, alignToRight = _a.actualBoundingBoxRight;
            alignToLeft = Math.ceil(alignToLeft);
            alignToRight = Math.ceil(alignToRight);
            if (actualWidth < alignToRight + alignToLeft) {
                actualWidth = alignToRight + alignToLeft;
            }
        }
        var canvasWidth = width;
        var canvasHeight = height;
        var textHeight = text.height || 0;
        var textWidth = text.width || 0;
        var diffHeight = canvasHeight * 0.1;
        var diffWidth = canvasWidth * 0.1;
        if (actualWidth > canvasWidth - diffWidth ||
            textHeight > canvasHeight - diffHeight) {
            var currentHeight = textHeight + diffHeight;
            var multiScale = findScaleToContain({ width: textWidth, height: currentHeight }, {
                width: canvasWidth,
                height: canvasHeight
            });
            if (multiScale <= 1)
                text.scale(multiScale);
        }
        else {
            text.scale(1);
        }
    };
    var handleChangeTempText = function (value) {
        var maxLength = selectedText.type === 'copywriting' ? 30 : 10;
        if (selectedText.maxLength !== undefined) {
            maxLength = selectedText.maxLength;
        }
        var lineLimit = selectedText.lineLimit !== undefined ? selectedText.lineLimit : -1;
        var lineBreaks = (value.match(/\n/g) || []).length;
        if (value.length > maxLength || (lineLimit >= 0 && lineBreaks >= lineLimit))
            return;
        if (typeof selectedEdit === 'string') {
            renderTempText(value, selectedEdit);
        }
        setEditTempText(value);
        setShowTextTip(false);
    };
    var handleSelectColor = function () {
        setColorVisiable(false);
    };
    var renderTextLimitArea = function () {
        if (!selectedText || !_canvas.current) {
            return null;
        }
        var canvasWidth = _canvas.current.getWidth();
        var canvasHeight = _canvas.current.getHeight();
        return (_jsx("div", { className: "_sz-absolute _sz-border _sz-border-dashed _sz-border-[var(--sunzi-theme-color)] _sz-bg-[var(--sunzi-theme-color-006)] _sz-cursor-pointer", style: {
                width: (selectedText.width / miniMeImage.width) * canvasWidth,
                height: (selectedText.height / miniMeImage.height) * canvasHeight,
                left: (selectedText.left / miniMeImage.width) * canvasWidth,
                top: (selectedText.top / miniMeImage.height) * canvasHeight
            } }));
    };
    useEffect(function () {
        changeAssect();
    }, [selectedColor]);
    useEffect(function () {
        fabric.Object.prototype.objectCaching = false;
        canvasInit();
    }, [currentSide, images]);
    useEffect(function () {
        renderTextImage()
            .then(function (result) {
            _textImage.current = result;
        })
            .catch(function () {
            _textImage.current = [];
        });
        return function () {
        };
    }, []);
    var handleFlipClick = function () {
        setOperatingFlip(true);
        setDirectToPreview(true);
        _canvas.current.discardActiveObject();
        _canvas.current.renderAll();
        addCanvasData();
        setFlipButtonClickTag(true);
        if (currentSide == 1) {
            setCurrentSide(currentSide + 1);
        }
        else {
            setCurrentSide(currentSide - 1);
        }
    };
    return (_jsxs("div", { className: "_sz-flex _sz-h-full _sz-flex-col _sz-overflow-hidden _sz-bg-white", children: [_jsx(Header, { className: "!_sz-z-[5] !_sz-h-12 _sz-shrink-0 _sz-bg-white", onClose: handleClose, renderCloseContent: colorVisiable ? (_jsx("div", {})) : (_jsx(Icon, { size: 24, color: "#000", children: _jsx(LeftIcon, {}) })), renderConfirmContent: _jsx("div", { ref: EditPageNextElement, className: "_sz-mr-4 _sz-cursor-pointer _sz-rounded _sz-bg-black _sz-py-2\t_sz-px-4 _sz-text-base _sz-font-black _sz-text-white ".concat(loading || colorVisiable
                        ? '_sz-pointer-events-none _sz-cursor-not-allowed _sz-touch-none !_sz-bg-[rgba(0,0,0,0.1)]'
                        : ''), onClick: function () {
                        handleConfirm();
                    }, children: I18n.format('next') }) }), loading && (_jsx("div", { className: "_sz-absolute _sz-inset-0 _sz-z-[3] _sz-flex _sz-items-center _sz-justify-center _sz-bg-white", children: _jsx(Loading, { color: "#ff533a", size: 60 }) })), _jsxs("div", { className: "_sz-relative _sz-flex-1 _sz-flex _sz-items-center", children: [productType === 'balloon' && (_jsx(VisualizeButton, { className: "_sz-absolute _sz-top-5 _sz-right-5 _sz-z-[2]", setViualizerPreviewVisible: setViualizerPreviewVisible, handleClick3dPreview: handleClick3dPreview })), _jsx(ColorButton, { className: "_sz-absolute _sz-top-5 _sz-left-5 _sz-z-[2]", colorVisiable: colorVisiable, setColorVisiable: setColorVisiable }), (currentSide == 2 || operatingFlip) && (_jsx(FlipButton, { className: "_sz-absolute _sz-top-5 _sz-right-5 _sz-z-[2]", handleFlip: handleFlipClick, currentSide: currentSide })), _jsxs("div", { className: "_sz-relative _sz-flex _sz-w-full _sz-justify-center", children: [_jsxs("div", { className: classNames(' _sz-relative  _sz-mx-[30px] _sz-w-full ', {
                                    '-_sz-mb-12 _sz-scale-[0.8]': miniMeImage.type === 'balloon'
                                }), children: [_jsx("div", { ref: _canvasWrapper, className: "_sz-relative _sz-w-full", children: _jsx("canvas", { ref: _element, className: "_sz-w-full" }) }), renderTextLimitArea()] }), showTextTip && (_jsx("div", { className: " _sz-absolute _sz-top-0  _sz-z-[2] _sz-w-full _sz-bg-white", children: _jsxs("div", { className: " _sz-flex _sz-items-center _sz-justify-center _sz-bg-[rgba(255,73,51,0.06)] _sz-p-2", children: [_jsx(Icon, { color: "#FF543E", size: 16, children: _jsx(IconLineEditPen, {}) }), _jsx("span", { className: " _sz-ml-1 _sz-text-sm _sz-text-[#FF543E]", children: I18n.format('lack.text.error') })] }) }))] })] }), _jsx("div", { className: classNames('_sz-w-full _sz-rounded-t-2xl _sz-bg-white  _sz-shadow-[0_-2px_8px_0px_rgba(0,0,0,0.06)] _sz-pb-4 sm:_sz-pb-0', isEditText ? '_sz-absolute _sz-bottom-0' : ''), children: isEditText ? (_jsxs("div", { className: "_sz-w-full _sz-px-4 _sz-pt-4 _sz-pb-5", children: [_jsxs("div", { className: " _sz-mb-5 _sz-flex _sz-justify-between", children: [_jsx("div", { className: " _sz-flex _sz-cursor-pointer _sz-items-center _sz-justify-center _sz-rounded-lg _sz-bg-[#F2F2F2] _sz-px-4 _sz-py-1.5", onClick: handleCloseEditText, children: _jsx(Icon, { size: 24, color: "#999999", children: _jsx(LineCloseIcon, {}) }) }), _jsx("div", { className: " _sz-flex _sz-cursor-pointer _sz-items-center _sz-justify-center _sz-rounded-lg _sz-bg-black  _sz-px-4 _sz-py-1.5", onClick: handleConfirmText, children: _jsx(Icon, { size: 24, color: "#FFFFFF", children: _jsx(LineCheckIcon, {}) }) })] }), _jsx("p", { className: " _sz-mb-2 _sz-text-base _sz-leading-[22px] _sz-text-black/[.88]", children: I18n.format('text.title') }), _jsxs("div", { className: " _sz-relative _sz-overflow-hidden _sz-rounded-lg _sz-border _sz-border-solid _sz-border-black/[.16]  _sz-bg-white", children: [selectedText && selectedText.type === 'copywriting' ? (_jsx("textarea", { rows: 3, placeholder: I18n.format('text.placeholder'), className: " _sz-w-full  _sz-resize-none _sz-border-none _sz-bg-white   _sz-p-4 _sz-pr-[58px] _sz-text-base _sz-text-black _sz-outline-none", onChange: function (e) { return handleChangeTempText(e.target.value); }, value: editTempText })) : (_jsx("input", { placeholder: I18n.format('text.placeholder'), className: " _sz-w-full  _sz-p-4  _sz-pr-[58px]  _sz-text-base", onChange: function (e) { return handleChangeTempText(e.target.value); }, value: editTempText })), selectedText && (_jsx("span", { className: " _sz-absolute _sz-right-4 _sz-top-4 _sz-text-sm _sz-leading-[22px] _sz-text-black/[.48]", children: "".concat(editTempText.length, "/").concat(selectedText.type === 'copywriting'
                                        ? (_c = selectedText.maxLength) !== null && _c !== void 0 ? _c : 30
                                        : (_d = selectedText.maxLength) !== null && _d !== void 0 ? _d : 10) }))] })] })) : (_jsx("div", { className: "_sz-flex _sz-w-full _sz-flex-wrap _sz-items-center _sz-justify-center _sz-gap-3 _sz-p-4", children: optionList.map(function (item) {
                        var isSelected = selectedEdit == item.id;
                        return (_jsxs("div", { className: classNames('_sz-relative _sz-h-[60px] _sz-w-[60px] _sz-cursor-pointer _sz-rounded-lg _sz-border _sz-border-solid _sz-border-black/[.06] _sz-p-[6px] ', isSelected
                                ? '!_sz-border-2 !_sz-border-[var(--sunzi-theme-color)] !_sz-bg-[var(--sunzi-theme-color-006)] !_sz-p-[5px]'
                                : '', typeof item.id === 'string' && item.id.startsWith('text')
                                ? '!_sz-p-0'
                                : ''), onClick: function () { return setActiveObject(item.id); }, children: [isSelected && (_jsx(Icon, { className: "_sz-absolute -_sz-right-1.5 -_sz-top-1.5", color: "var(--sunzi-theme-color)", size: 20, children: _jsx(SubscriptIcon, {}) })), _jsx("img", { src: item.image, className: "_sz-h-full _sz-w-full _sz-object-contain" })] }, "".concat(item.id)));
                    }) })) }), colorVisiable && (_jsx(ColorDrawer, { className: "!_sz-top-12 ", onSelectConfirm: handleSelectColor }))] }));
};
export default Preview;
